import React, { PureComponent } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import { runReportByYearMonthly, getYearColor } from "./utils";

export default class YTDBikesAccumulative extends PureComponent {
  render() {
    const { bikes, statuses, dateField } = this.props;

    if (!bikes) {
      return "n/a";
    }

    const { data, years } = runReportByYearMonthly(
      bikes.filter(bike => statuses.includes(bike.status)),
      dateField,
      (recordsThisMonth, previousResult, { getLastRealResult }) =>
        (recordsThisMonth ? recordsThisMonth.length : 0) +
        (previousResult || getLastRealResult() || 0)
    );

    return (
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" interval={0} height={40} />
          <YAxis />
          <Tooltip />
          <Legend />
          {years.map((year, i) => (
            <Line
              key={`line-${year}`}
              dataKey={year}
              stroke={getYearColor(year)}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    );
  }
}
